/* Shape Footer
   - Loads the footer fonts only when the footer comes near the screen
   - Plays the wordmark animation only while it is visible
   Tiny, deferred, no libraries, nothing runs during page load. */
(function () {
  var FONTS_URL = 'https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500&family=IBM+Plex+Sans:wght@400;500&display=swap';
  var fontsLoaded = false;

  function loadFonts() {
    if (fontsLoaded) return;
    fontsLoaded = true;
    var pre = document.createElement('link');
    pre.rel = 'preconnect';
    pre.href = 'https://fonts.gstatic.com';
    pre.crossOrigin = '';
    document.head.appendChild(pre);
    var css = document.createElement('link');
    css.rel = 'stylesheet';
    css.href = FONTS_URL;
    document.head.appendChild(css);
  }

  if (!('IntersectionObserver' in window)) {
    if (document.querySelector('.sf[data-sf-fonts]')) loadFonts();
    return;
  }

  // Fonts: start fetching ~800px before the footer is visible
  var fontIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) { loadFonts(); fontIO.disconnect(); }
    });
  }, { rootMargin: '800px 0px' });

  // Wordmark: animate only while on screen
  var wmIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      entry.target.classList.toggle('is-playing', entry.isIntersecting);
    });
  }, { rootMargin: '0px 0px -10% 0px' });

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.sf[data-sf-fonts]').forEach(function (el) { fontIO.observe(el); });
    scope.querySelectorAll('.sf-wm[data-animate]').forEach(function (el) {
      if (el.dataset.sfBound) return;
      el.dataset.sfBound = '1';
      wmIO.observe(el);
    });
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(function () { init(); }, { timeout: 2000 });
  } else {
    window.addEventListener('load', function () { init(); });
  }

  // Theme editor: re-bind when the section is re-rendered
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();